export default "__VITE_PUBLIC_ASSET__0bdf7743__"